import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
/**
 * ErrorInterceptor intercepts HTTP responses from the API to check if there were any errors.
 * If there is a 403 Forbidden response the user is automatically logged out of the application,
 * all other errors are re-thrown up to the calling service.
 */
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 403) {
        // Auto logout if 403 response returned from API.
        this.auth.logout(false).subscribe(_ => {
          this.router.navigate(['/']);
        });
        this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
      }
      return throwError(err);
    }));
  }
}
